import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Trash } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { IconButton } from "@air/primitive-icon-button";
import React, { memo } from "react";
import { CLEAR_FILTER_BTN, REMOVE_FILTER_BTN } from "~/constants/testIDs";
export const FilterCardFooter = /*#__PURE__*/ memo((param)=>{
    let { onDeleteClick, onClearClick } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center justify-end p-1",
        children: [
            !!onClearClick && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        appearance: "ghost",
                        color: "grey",
                        "data-testid": CLEAR_FILTER_BTN,
                        onClick: onClearClick,
                        size: "small",
                        children: "Clear"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mx-3 h-4 w-px bg-grey-5"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                color: "grey",
                "data-testid": REMOVE_FILTER_BTN,
                icon: Trash,
                label: "Remove filter",
                onClick: onDeleteClick,
                size: "small"
            })
        ]
    });
});
FilterCardFooter.displayName = "FilterCardFooter";
